import {
  getRefundsRequest,
  getRefundReasonsRequest,
  refundPaymentRequest,
} from "@/helpers/api/refunds";

const state = {
  pageRefundsList: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  refundReasons: [
    { code: "user_request", label: "Заявление пользователя" },
    { code: "duplicate_payment", label: "Дублирующая оплата" },
    { code: "wrong_tariff", label: "Ошибочный тариф / объект" },
    { code: "wrong_access_type", label: "Ошибочный тип доступа" },
    { code: "service_not_provided", label: "Услуга не оказана" },
    { code: "card_lost", label: "Утеря карты / отказ от карты" },
    { code: "other", label: "Другое" },
  ],
};

const getters = {
  getPageRefundsList: (state) => state.pageRefundsList,
  getRefundReasons: (state) => state.refundReasons,
};

const actions = {
  fetchPageRefundsList(context) {
    const query = context.getters.getPageQuery.query;
    const ordering = context.getters.getOrdering;
    return new Promise((resolve, reject) => {
      getRefundsRequest({
        query: {
          ordering,
          ...query,
        },
      })
        .then((response) => {
          context.commit("setRefundsList", {
            listName: "pageRefundsList",
            refunds: response.data,
          });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchRefundReasons(context) {
    return new Promise((resolve, reject) => {
      getRefundReasonsRequest()
        .then((response) => {
          context.commit("setRefundReasons", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  submitPaymentRefund(context, { paymentId, formData, isSbp }) {
    return refundPaymentRequest({ id: paymentId, formData, isSbp });
  },

  clearRefundsPage(context) {
    context.commit("clearRefundsList", { listName: "pageRefundsList" });
    return Promise.resolve();
  },
};

const mutations = {
  setRefundsList(state, { listName, refunds }) {
    state[listName] = refunds;
  },
  clearRefundsList(state, { listName }) {
    state[listName] = {
      count: 0,
      next: null,
      previous: null,
      results: [],
    };
  },
  setRefundReasons(state, reasons) {
    state.refundReasons = reasons;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
